import React from 'react'
import { Box, Paper, Typography, IconButton } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { AutoCoderCode } from '../../../types/gotypes'

interface CodeCardProps {
  code: AutoCoderCode
  color?: string
  compact?: boolean
  readOnly?: boolean
  onEdit?: () => void
  onDelete?: () => void
}

const CodeCard: React.FC<CodeCardProps> = ({
  code,
  color,
  compact = false,
  readOnly = true,
  onEdit,
  onDelete,
}) => {
  const indicatorColor = color || '#CBD5F5'

  return (
    <Paper
      variant="outlined"
      sx={{
        p: compact ? 0.75 : 1.5,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        borderLeft: `4px solid ${indicatorColor}`,
      }}
    >
      <Box
        sx={{
          width: compact ? 8 : 12,
          height: compact ? 8 : 12,
          borderRadius: '50%',
          backgroundColor: indicatorColor,
          mt: compact ? 0.4 : 0.5,
          flexShrink: 0,
        }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: compact ? '0.7rem' : '0.75rem',
            lineHeight: 1.2,
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            fontWeight: 500,
          }}
        >
          {code.text || code.code}
        </Typography>
        {!compact && code.description && (
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              color: 'text.secondary',
              fontSize: '0.65rem',
              lineHeight: 1.3,
              mt: 0.25,
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {code.description}
          </Typography>
        )}
      </Box>
      {!readOnly && (onEdit || onDelete) && (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, flexShrink: 0 }}>
          {onEdit && (
            <IconButton size="small" onClick={onEdit}>
              <EditIcon sx={{ fontSize: compact ? 14 : 18 }} />
            </IconButton>
          )}
          {onDelete && (
            <IconButton size="small" onClick={onDelete}>
              <DeleteIcon sx={{ fontSize: compact ? 14 : 18 }} />
            </IconButton>
          )}
        </Box>
      )}
    </Paper>
  )
}

export default CodeCard
